import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"icon-play\"><path fill-rule=\"evenodd\" d=\"M9.5.75a8.251 8.251 0 010 16.5 8.25 8.25 0 010-16.5zM7.764 5l5.816 3.574a.505.505 0 01.246.45c0 .179-.097.352-.253.445l-5.816 3.545a.527.527 0 01-.528.01.53.53 0 01-.266-.46V5.45a.527.527 0 01.8-.45z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol